"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callBoth = callBoth;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
function callBoth() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var lastResult;
    fns.forEach(function (fn) {
      if (typeof fn === 'function') {
        lastResult = fn.apply(void 0, args);
      }
    });
    return lastResult;
  };
}